module.exports = __webpack_public_path__ + "img/icon-percentage.c3934153.svg";